import React from 'react'
import {
  ClipboardList,
  FolderKanban,
  LayoutDashboard,
  TrendingUp,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { EmployeeDetailTab } from '../../../hooks/use-employee-detail-page'

const TABS: { id: EmployeeDetailTab; label: string; Icon: LucideIcon }[] = [
  { id: 'overview', label: 'Overview', Icon: LayoutDashboard },
  { id: 'trends', label: 'Trends', Icon: TrendingUp },
  { id: 'projects', label: 'Projects', Icon: FolderKanban },
  { id: 'details', label: 'Details', Icon: ClipboardList },
]

export interface EmployeeDetailTabBarProps {
  activeTab: EmployeeDetailTab
  onTabChange: (t: EmployeeDetailTab) => void
}

/** Same chrome as `ProjectDetailTabBar`. */
export function EmployeeDetailTabBar({
  activeTab,
  onTabChange,
}: EmployeeDetailTabBarProps) {
  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-md overflow-hidden">
      <div className="flex border-b border-slate-200 overflow-x-auto">
        {TABS.map(({ id, label, Icon }) => {
          const active = activeTab === id
          return (
            <button
              key={id}
              type="button"
              onClick={() => onTabChange(id)}
              className={`flex items-center gap-2 px-5 py-3.5 text-[12px] font-semibold whitespace-nowrap transition-all border-b-2 -mb-px flex-none ${
                active
                  ? 'border-blue-500 text-blue-600 bg-blue-50/30'
                  : 'border-transparent text-slate-500 hover:text-slate-700 hover:bg-slate-50'
              }`}
            >
              <Icon
                size={13}
                className={active ? 'text-blue-500' : 'text-slate-600'}
              />
              {label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
